
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folders/[...folder]",
      function () {
        return require("private-next-pages/folders/[...folder].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folders/[...folder]"])
      });
    }
  